import layout from "../layout.css?inline"
import rtlLayout from "../rtl-layout.css?inline"
import scroll from "../scrollbar.css?inline"
export default layout + rtlLayout + scroll
